import React, { useState, createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  const contextObject = useMemo(() => ({ user, login, logout }), [user]);

  return <AuthContext.Provider value={contextObject}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.object,
};

AuthProvider.defaultProps = {
  children: {},
};

export const useAuth = () => useContext(AuthContext);
